<template>
  <RouterView
    @onStartEvent="onStartEvent"
    @onEndEvent="onEndEvent"
  />
</template>

<script>
import format from '@/utils/format';
let eventTime;

export default {
  name: 'Index',
  methods: {
    onStartEvent () {
      eventTime = Math.trunc(Date.now() / 1000);
    },
    onEndEvent () {
      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        eventAction: 'ÜrünListesiDropdownMenüTekilÜrünEklemeBasarılı',
        eventLabel: format.formatTime(Math.trunc(Date.now() / 1000) - eventTime),
      });
      this.$root.trackEvent({
        eventCategory: 'Time Difference',
        eventAction: 'SPM - Trendyol Kataloğundan Ekle',
        eventLabel: format.formatTime(Math.trunc(Date.now() / 1000) - eventTime),
      });
    },
  },
};
</script>
